/**
 * curriculum.json is now stored on S3 in aqua-extended bucket. direct link
 * to Best Buddy curriculum folder:
 * https://s3.console.aws.amazon.com/s3/buckets/aqua-extended/gc/best_buddy/curriculum/?region=us-west-2&tab=overview
 *
 * This file is to store the curriculum when it is fetched and offer hooks to retrieve the fetched curriculum when needed.
 *
 * Best Buddy curriculum JSON is generated in a google spreadsheet. See the "dev JSON" tab, cell B9:
 * https://docs.google.com/spreadsheets/d/1R4FiVQKtOKtozQvKLo0ve7osS_OzlxRGHChmKf98YM8/edit#gid=906160152
 */

let curriculum = {};

export const getCurriculum = () => curriculum;
export const setCurriculum = (c) => { curriculum = c; };
